module.exports = "<div class=\"title\">\r\n        {{title}}\r\n    </div>\r\n\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/claims/claims/claims.component.html
// module id = ./src/app/ultilities/claims/claims/claims.component.html
// module chunks = main